import React from 'react';
import { Typography } from '@mui/material';

type Situacao = 'Novo' | 'Em andamento' | 'Finalizado' | 'Em coleta (Rascunho)' | 'Sincronizado' | 'Enviado ao Estado';

const getSituacaoColor = (situacao: Situacao): string => {
  switch (situacao) {
    case 'Novo':
      return 'blue';
    case 'Finalizado':
      return 'green';
    case 'Sincronizado':
      return 'purple';
    case 'Enviado ao Estado':
      return 'orange';
    default:
      return 'orange';
  }
};

const StatusBadge: React.FC<{ situacao: Situacao }> = ({ situacao }) => (
  <Typography component="span" fontWeight="bold" sx={{ color: getSituacaoColor(situacao) }}>
    {situacao}
  </Typography>
);

export default StatusBadge;
